<template>
  <div>
    <v-chip v-if="maxQuantity > 0" text-color="white" color="green">
      Can produce up to &nbsp; 
      <span class="font-weight-bold">
        <c-ms-ii
        :metric_definition="item" 
        :realValue.sync="maxQuantity"
        :key="'c' + (item.definition || {}).id"
        alwaysScale
        labelMode
        ></c-ms-ii>
      </span>
    </v-chip>

    <v-chip v-else>
      Insufficient inventory
    </v-chip>

  </div>
</template>

<script>
import JsonViewer from '@/components/toolbox/json-viewer/Main'

export default {
  props: {
    item: null
  },
  components: {
    JsonViewer
  },
  data () {
    return {
      inventoryMapBuild: {},
      build: null
    }
  },
  watch: {
    item (nv) {
      this.reload()
    },
    inventorySetBuild (nv) {
      this.fetchInventory(this.inventorySetBuild)
        .then(map => {
          this.inventoryMapBuild = map
        })
    }
  },
  computed: {
    inventorySetBuild () {
      var buildItems = ( this.build || {}).items || []
      return [...new Set(buildItems.map(item => item.inventory_item_id))]
    },
    totalRecipeTimes1 () {
      var map = {}
      var items = (this.build || {}).items || []
      items.forEach(item => {
        if (map[item.inventory_item_id]) {
          map[item.inventory_item_id] += item.quantity
        } else {
          map[item.inventory_item_id] = item.quantity
        }
      })
      return map
    },
    totalInventoryMapBUILD () {
      var map = {}
      Object.keys(this.inventoryMapBuild).map((key, index) => {
        map[key] = this.inventoryMapBuild[key].reduce((a, i) => a + i.quantity, 0)
      })
      return map
    },
    maxQuantityDict () {
      var map = {}
      Object.keys(this.totalRecipeTimes1).forEach(inventory_item_id => {
        var max = Math.floor(this.totalInventoryMapBUILD[inventory_item_id] / this.totalRecipeTimes1[inventory_item_id])
        map[inventory_item_id] = max || 0
      })
      return map
    },
    maxQuantity () {
      if (Object.keys(this.maxQuantityDict).length < 1) {
        return 0
      }
      return Object.values(this.maxQuantityDict).reduce((a, i) => i < a ? i : a)
    }
  },
  methods: {
    fetchBuilds () {
      return new Promise((resolve, reject) => {
        this.$axios.get(`/product-builds/inventory-item/${this.item.id}`)
          .then(response => {
            resolve(response.data.rows)
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    },
    fetchInventory (_set) {
      return new Promise((resolve, reject) => {
        this.$axios.post(`/inventory/inventory-item-id/multiple`, _set)
          .then(response => {
            resolve(response.data.map)
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    },
    reload () {
      this.fetchBuilds()
        .then(builds => {
          if (builds.length > 0) {
            this.build = builds[0]
          } else {
            this.build = null
          }
        })
    }
  },
  created () {
    this.reload()
  }
}
</script>